import { render } from "./ClassDetails.vue?vue&type=template&id=3944dc84&scoped=true"
import script from "./ClassDetails.vue?vue&type=script&lang=js"
export * from "./ClassDetails.vue?vue&type=script&lang=js"

import "./ClassDetails.vue?vue&type=style&index=0&id=3944dc84&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3944dc84"

export default script